let _id = 0;
export function uid() {
  return `nuid-${_id++}`;
}
